import toNumeric from './string-num-val'

export const colors = {
  0: '#FF3D00',
  1: '#b2efd2',
  2: '#00bcd4',
  3: '#0097a7',
  4: '#ffd54f',
  5: '#ffc107',
  6: '#ff8f00',
  7: '#91e573',
  8: '#00e676',
  9: '#30d786',
}

function genRngHex (seed: string) {
  return colors[ toNumeric(seed) % 10 ]
}

export default genRngHex



// WEBPACK FOOTER //
// ./src/utils/rng-hex.ts